import { recomposeColor, rgbToHex } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import VoxelInput from '../../../components/voxel/Forms/VoxelInput';

export interface RGBColorPickerProps {
  color: string;
  rgbColor: number[];
  setColor: (color: string) => void;
}

export const RGBColorPicker: React.FC<RGBColorPickerProps> = ({ rgbColor, setColor, color }) => {
  const [localRgb, setLocalRgb] = useState<(number | undefined)[]>(rgbColor);

  // Reset local color if needed
  useEffect(() => {
    if (rgbColor.every((value, index) => value === localRgb[index])) return;
    setLocalRgb(rgbColor);
  }, [rgbColor]);

  const handleChange = (index: number, textValue?: string) => {
    const value = textValue?.replaceAll(/[^0-9]+/gm, '')?.slice(0, 3);
    const cleanedValue = value?.length === 0 ? 0 : Math.max(Math.min(+value, 255), 0);
    setLocalRgb((prev) =>
      prev.map((prevValue, prevIndex) => (prevIndex === index ? cleanedValue : prevValue))
    );
  };

  useEffect(() => {
    try {
      const composedLocalColor = recomposeColor({ type: 'rgb', values: localRgb as any });
      const hexLocalColor = rgbToHex(composedLocalColor);
      if (hexLocalColor?.length !== 7) return;
      if (hexLocalColor?.toLocaleLowerCase() === color?.toLowerCase()) return;

      // If decomposing color worked that means we can update the color
      setColor(hexLocalColor);
    } catch {
      console.log('crash');
    }
  }, [localRgb]);

  return (
    <div className="flex flex-row gap-2 w-64">
      <VoxelInput
        value={localRgb[0] ?? ''}
        deleteValue={() => handleChange(0, undefined)}
        onChange={(event) => handleChange(0, event.target.value)}
        id="R"
        label="R"
        labelPosition="top"
      />
      <VoxelInput
        value={localRgb[1] ?? ''}
        deleteValue={() => handleChange(1, undefined)}
        onChange={(event) => handleChange(1, event.target.value)}
        id="G"
        label="G"
        labelPosition="top"
      />
      <VoxelInput
        value={localRgb[2] ?? ''}
        deleteValue={() => handleChange(2, undefined)}
        onChange={(event) => handleChange(2, event.target.value)}
        id="B"
        label="B"
        labelPosition="top"
      />
    </div>
  );
};

export default RGBColorPicker;
